module.exports = __webpack_public_path__ + "static/media/ā_64k.da6c5fd9.mp3";